import Resource from '@/api/resources/Resource'

class SubportionRevisionServices extends Resource {
    async getAllSubportionRevisions(caseId, sampleId, portionId, subportionId, laboratoryId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/subportions/${subportionId}/revisions`)
        return response.data
    }

    async getSubportionRevision(caseId, sampleId, portionId, subportionId, revisionId, laboratoryId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/subportions/${subportionId}/revisions/${revisionId}`)
        return response.data
    }

    async getSubportionUnfinishedRevision(caseId, sampleId, portionId, subportionId, laboratoryId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/subportions/${subportionId}/revisions/unfinished`)
        return response.data
    }
}

export default new SubportionRevisionServices()
